var exports = {
  "kL": "xa15a2ab7--490278--container",
  "kb": "xa15a2ab7--490278--left",
  "DD": "xa15a2ab7--490278--title",
  "g_": "xa15a2ab7--490278--proofs",
  "Uo": "xa15a2ab7--490278--buttons",
  "x6": "xa15a2ab7--490278--button",
  "my": "xa15a2ab7--490278--avatar",
  "D9": "xa15a2ab7--490278--phones-opened-info",
  "o3": "xa15a2ab7--490278--super-agent",
};

module.exports = exports;
